import { DateTime } from 'luxon';
import { fromJsonArray } from 'src/core/utils';

export class CustomerDownloadTopic {
    public readonly normalizedName: string;

    public readonly localizedName: string;

    constructor(json: Record<string, any>) {
        this.normalizedName = json.normalizedName;
        this.localizedName = json.localizedName;
    }
}

export class CustomerDownload {
    public readonly normalizedName: string;

    public readonly localizedName: string;

    public readonly defaultResourceUrl?: string;

    public readonly localizedDownloads: CustomerLocalizedDownload[];

    constructor(json: Record<string, any>) {
        this.normalizedName = json.normalizedName;
        this.localizedName = json.localizedName;
        this.defaultResourceUrl = json.defaultResourceUrl;
        this.localizedDownloads = fromJsonArray(CustomerLocalizedDownload, json.localizedDownloads);
    }
}

export class CustomerLocalizedDownload {
    public readonly countryIso2: string;

    public readonly languageIso2: string;

    public readonly resourceUrl?: string;

    public readonly uploadedOn: DateTime;

    constructor(json: Record<string, any>) {
        this.countryIso2 = json.countryIso2;
        this.languageIso2 = json.languageIso2;
        this.resourceUrl = json.resourceUrl;
        this.uploadedOn = DateTime.fromISO(json.uploadedOn);
    }
}
